"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var semantic_ui_react_1 = require("semantic-ui-react");
var react_intersection_observer_1 = require("react-intersection-observer");
var index_module_scss_1 = __importDefault(require("./index.module.scss"));
var react_i18next_1 = require("react-i18next");
function CollectionsSection() {
    var _a = (0, react_intersection_observer_1.useInView)({
        rootMargin: "0px 0px",
    }), ref = _a.ref, inView = _a.inView;
    var discoverList = [
        {
            name: ((0, jsx_runtime_1.jsxs)("p", { children: ["Concert & ", (0, jsx_runtime_1.jsx)("br", {}), "Event Ticketing"] })),
            url: "events",
            bg: "/assets/images/collectibles/collectible_1.png",
            disabled: false
        },
        {
            name: ((0, jsx_runtime_1.jsxs)("p", { children: ["Private ", (0, jsx_runtime_1.jsx)("br", {}), " Membership"] })),
            url: "private-memberships",
            bg: "/assets/images/collectibles/collectible_4.png",
            disabled: false
        },
        {
            name: (0, jsx_runtime_1.jsx)("p", { children: "Music NFT" }),
            url: "music",
            bg: "/assets/images/collectibles/collectible_3.png",
            disabled: false
        },
        {
            name: (0, jsx_runtime_1.jsx)("p", { children: "Merchandise" }),
            url: "#",
            bg: "/assets/images/collectibles/collectible_2.png",
            disabled: true
        },
        {
            name: (0, jsx_runtime_1.jsx)("p", { children: "Giveaways" }),
            url: "#",
            bg: "/assets/images/collectibles/collectible_5.png",
            disabled: true
        },
        {
            name: ((0, jsx_runtime_1.jsxs)("p", { children: ["Metaverse ", (0, jsx_runtime_1.jsx)("br", {}), " Experience"] })),
            url: "#",
            bg: "/assets/images/collectibles/collectible_6.png",
            disabled: true
        },
        {
            name: (0, jsx_runtime_1.jsx)("p", { children: "Digital Media" }),
            url: "digital",
            bg: "/assets/images/collectibles/collectible_7.png",
            disabled: false
        },
        {
            name: (0, jsx_runtime_1.jsx)("p", { children: "Token and Crypto" }),
            url: "#",
            bg: "/assets/images/collectibles/collectible_8.png",
            disabled: true
        },
    ];
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: index_module_scss_1.default.benefits }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: index_module_scss_1.default.container, ref: ref, style: inView
                    ? {
                        transform: "scale(1)",
                        filter: "grayscale(0)",
                        transition: "ease-in-out 0.5s",
                    }
                    : {
                        transform: "scale(0.8)",
                        filter: "grayscale(1)",
                        opacity: "0.5",
                        transition: "ease-in-out 0.8s",
                    } }, { children: [(0, jsx_runtime_1.jsx)("h3", __assign({ style: { marginBottom: "20px" } }, { children: (0, jsx_runtime_1.jsx)(react_i18next_1.Trans, { children: "navTypesOfCollectibles" }) })), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, __assign({ columns: "four", divided: true }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Row, __assign({ className: index_module_scss_1.default.row }, { children: discoverList === null || discoverList === void 0 ? void 0 : discoverList.map(function (element, index) {
                                return ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid.Column, __assign({ className: index_module_scss_1.default.column }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Card, __assign({ className: index_module_scss_1.default.benefit, href: "/collectibles/".concat(element.url), disabled: true }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Card.Content, __assign({ className: index_module_scss_1.default.content }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Card.Header, __assign({ className: element.disabled && (index_module_scss_1.default.disabled) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: index_module_scss_1.default.collection_profile }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: index_module_scss_1.default.benefits_details }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: index_module_scss_1.default.image_container }, { children: [(0, jsx_runtime_1.jsx)("img", { src: element.bg }), (0, jsx_runtime_1.jsx)("p", __assign({ className: index_module_scss_1.default.details }, { children: element.name }))] })) })) })) })) })) })) }), index));
                            }) })) }))] })) })) }));
}
exports.default = CollectionsSection;
